var _g, _rect, _g2, _g3, _rect2, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTradingRewards = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3682_16843)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_3682_16843)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3682_16843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint1_linear_3682_16843)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3682_16843)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3682_16843)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.867,
    cy: 37.798,
    rx: 9.629,
    ry: 8.969,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3682_16843)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.305,
    cy: 13.325,
    rx: 12.053,
    ry: 5.367,
    fill: "url(#paint2_linear_3682_16843)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3682_16843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.153 46.657 1.827-13.625-7.107-.427 16.408-18.89-3.607 13.593 6.53.383-14.051 18.966Z",
    fill: "#1F1C1B"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 6.25,
    width: 47.5,
    height: 47.5,
    rx: 23.75,
    stroke: "url(#paint3_linear_3682_16843)",
    strokeWidth: 0.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_3682_16843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.33 32.075-1.652 10.782 10.179-14.043-6.045-.25L33.942 18 22.285 31.75l6.045.325Z",
    fill: "url(#paint4_linear_3682_16843)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3682_16843",
    x1: 30,
    y1: 6,
    x2: 30,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3682_16843",
    x1: 30,
    y1: 6,
    x2: 30,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3682_16843",
    x1: 24.102,
    y1: 6.197,
    x2: 10.185,
    y2: 7.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96EFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3682_16843",
    x1: 30,
    y1: 6,
    x2: 30,
    y2: 28.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3682_16843",
    x1: 29.571,
    y1: 18,
    x2: 29.571,
    y2: 42.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3682_16843",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3682_16843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3682_16843",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3682_16843",
    x: 4.238,
    y: 2.829,
    width: 71.258,
    height: 69.937,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_3682_16843"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3682_16843",
    x: -12.904,
    y: -8.197,
    width: 56.417,
    height: 43.044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.078,
    result: "effect1_foregroundBlur_3682_16843"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3682_16843",
    x: 18.873,
    y: 13.216,
    width: 21.331,
    height: 34.941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3682_16843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3682_16843",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_3682_16843",
    x: 22.285,
    y: 18,
    width: 14.572,
    height: 25.057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3682_16843"
  })))));
};
export default SvgTradingRewards;